<template>
  <div>
    <span class="title">{{ value }}</span>
    <span class="subtitle">{{ subtitle }}</span>
  </div>
</template>

<script>
export default {
  name: 'GradientText',
  props: {
    value: { type: String, default: '' },
    subtitle: { type: String, default: '' },
  },
  data() {
    return {}
  },
}
</script>

<style lang="scss" scoped>
.title {
  background: linear-gradient(to bottom, #9334ff, #ab21cd);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 60px;
  font-weight: bold;
  display: flex;
  flex-direction: column;
  @media screen and (max-width: 768px) {
    font-size: 40px !important;
  }
}
.subtitle {
  font-size: 24px;
  color: #fff;
  margin-top: 20px;
  @media screen and (max-width: 768px) {
    font-size: 24px !important;
  }
}
</style>
